import Axios from "axios"


class MyUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                const branch_id = window.EventManager.branchInfo.id
                const notice_id = document.getElementById('notice_id')

                const data = new FormData();
                data.append('branch_id', branch_id)
                data.append('notice_id', notice_id.value)
                data.append('image', file); 

                Axios
                .post("/notice/image/save", data)
                .then(res => {
                    console.log(res.data)
                    resolve({
                        default: res.data.src
                    });
                    notice_id.value = res.data['id']
                })
                .catch(error => {
                    reject(error.message);
                });
            }));
    }

    abort() {
    }
}

export function create(props) {
    const content = props['content']
    const Set_ckeditor = props['Set_ckeditor']

    const LICENSE_KEY = 'GPL'

    const ck = window['CKEDITOR']

    const Alignment = ck['Alignment']
    const AutoImage = ck['AutoImage']
    const Autosave = ck['Autosave']
    const Bold = ck['Bold']
    const CloudServices = ck['CloudServices']
    const Essentials = ck['Essentials']
    const FontBackgroundColor = ck['FontBackgroundColor']
    const FontColor = ck['FontColor']
    const FontFamily = ck['FontFamily']
    const FontSize = ck['FontSize']
    const Heading = ck['Heading']
    const Highlight = ck['Highlight']
    const HorizontalLine = ck['HorizontalLine']
    const ImageBlock = ck['ImageBlock']
    const ImageCaption = ck['ImageCaption']
    const ImageInline = ck['ImageInline']
    const ImageInsertViaUrl = ck['ImageInsertViaUrl']
    const ImageStyle = ck['ImageStyle']
    const ImageTextAlternative = ck['ImageTextAlternative']
    const ImageToolbar = ck['ImageToolbar']
    const ImageUpload = ck['ImageUpload']
    const ImageResize = ck['ImageResize']
    const Indent = ck['Indent']
    const IndentBlock = ck['IndentBlock']
    const Italic = ck['Italic']
    const Link = ck['Link']
    const LinkImage = ck['LinkImage']
    const List = ck['List']
    const MediaEmbed = ck['MediaEmbed']
    const Paragraph = ck['Paragraph']
    const Strikethrough = ck['Strikethrough']
    const Table = ck['Table']
    const TableCaption = ck['TableCaption']
    const TableToolbar = ck['TableToolbar']
    const Underline = ck['Underline']

    const translations = ck['translations']

    const editorConfig = {
        toolbar: {
            items: [
                'undo',
                'redo',
                '|',
                'heading',
                '|',
                'fontSize',
                'fontFamily',
                'fontColor',
                'fontBackgroundColor',
                '|',
                'bold',
                'italic',
                'underline',
                'strikethrough',
                'highlight',
                '|',
                'alignment',
                'outdent',
                'indent',
                'bulletedList',
                'numberedList',

                'link',
                'mediaEmbed',
                'insertimage',
                'insertTable',
                'horizontalline'
            ],
            shouldNotGroupWhenFull: true
        },
        plugins: [
            Alignment,
            AutoImage,
            Autosave,
            Bold,
            CloudServices,
            Essentials,
            FontBackgroundColor,
            FontColor,
            FontFamily,
            FontSize,
            Heading,
            Highlight,
            HorizontalLine,
            ImageBlock,
            ImageCaption,
            ImageInline,
            ImageInsertViaUrl,
            ImageStyle,
            ImageTextAlternative,
            ImageToolbar,
            ImageUpload,
            ImageResize,
            Indent,
            IndentBlock,
            Italic,
            Link,
            LinkImage,
            List,
            MediaEmbed,
            Paragraph,
            Strikethrough,
            Table,
            TableCaption,
            TableToolbar,
            Underline
        ],
        fontFamily: {
            supportAllValues: true
        },
        fontSize: {
            options: [10, 12, 14, 'default', 18, 20, 22],
            supportAllValues: true
        },
        heading: {
            options: [
                {
                    model: 'paragraph',
                    title: 'Paragraph',
                    class: 'ck-heading_paragraph'
                },
                {
                    model: 'heading1',
                    view: 'h1',
                    title: 'Heading 1',
                    class: 'ck-heading_heading1'
                },
                {
                    model: 'heading2',
                    view: 'h2',
                    title: 'Heading 2',
                    class: 'ck-heading_heading2'
                },
                {
                    model: 'heading3',
                    view: 'h3',
                    title: 'Heading 3',
                    class: 'ck-heading_heading3'
                },
                {
                    model: 'heading4',
                    view: 'h4',
                    title: 'Heading 4',
                    class: 'ck-heading_heading4'
                },
                {
                    model: 'heading5',
                    view: 'h5',
                    title: 'Heading 5',
                    class: 'ck-heading_heading5'
                },
                {
                    model: 'heading6',
                    view: 'h6',
                    title: 'Heading 6',
                    class: 'ck-heading_heading6'
                }
            ]
        },
        image: {
            toolbar: ['toggleImageCaption', 'imageTextAlternative', '|', 'imageStyle:inline', 'imageStyle:wrapText', 'imageStyle:breakText']
        },
        language: 'ko',
        licenseKey: LICENSE_KEY,
        link: {
            addTargetToExternalLinks: true,
            defaultProtocol: 'https://',
            decorators: {
                toggleDownloadable: {
                    mode: 'manual',
                    label: 'Downloadable',
                    attributes: {
                        download: 'file'
                    }
                }
            }
        },
        placeholder: '',
        table: {
            contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        },
        translations: [translations]
    };

    window['CKEDITOR']['ClassicEditor']
    .create(
        document.getElementById('ckeditor'),
        editorConfig
    ).then((contents) => {
        contents.setData(content)

        contents.plugins.get('FileRepository').createUploadAdapter = (loader) => {
            return new MyUploadAdapter(loader)
        }

        Set_ckeditor(contents)
    })
}